import React from 'react';
import styled from '@emotion/styled';
import { Flex } from '$components/layouts';

export const ProductCtaSection = () => {
    return (
        <Flex alignItems="center">
            <WishCloudButton id="gowishRoundedButton" type="button" data-region="denmark" />
        </Flex>
    );
};

const WishCloudButton = styled.button(({ theme }) => ({
    all: 'unset',
    height: '48px',
    width: '48px',
    backgroundColor: theme.colors.white,
    boxShadow: '0px 4px 12px 0px #0000001F',
    cursor: 'pointer',
    borderRadius: theme.general.circleRadius,
    position: 'relative',
    backgroundImage: 'url("/wish-cloud-full.svg")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: '24px',
}));
